import AnnualReportSection from "./AnnualReportSection";
import ChiefExecutiveOfficerSection from "./ChiefExecutiveOfficerSection";
import ChiefFinancialofficerSection from "./ChiefFinancialOfficerSection";
import InvestorRelationsSection from "./InvestorRelationsSection";
import ManagedBoardSection from "./ManagedBoardSection";
import RiskManagementSection from "./RiskManagementSection";
import SpecialRecognitionAwardSection from "./SpecialRecognitionAwardSection";

/**
 * Component to render eligibility tab data in SCA how to nominate page
 */
const EligibilityPage = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="eligibility-page-component"
    >
      <ManagedBoardSection />

      <ChiefExecutiveOfficerSection />

      <ChiefFinancialofficerSection />

      <RiskManagementSection />

      <InvestorRelationsSection />

      <AnnualReportSection />

      <SpecialRecognitionAwardSection />
    </div>
  );
};

export default EligibilityPage;
